const UNITS = ["B", "KiB", "MiB", "GiB", "TiB", "PiB"];

/**
 * バイト数を 1024 進数の人間可読な文字列にする (例: 1610612736 → "1.5 GiB")。
 * バイト単位は整数、それ以外は小数第1位まで表示する。総容量の表記 (例: 20Gi) と
 * 揃うよう 1024 を基数とし、単位も 2 進接頭辞 (GiB 等) で表記する。
 */
export function formatBytes(bytes: number): string {
	if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
	const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
	const value = bytes / 1024 ** i;
	const formatted = i === 0 ? String(Math.round(value)) : value.toFixed(1);
	return `${formatted} ${UNITS[i]}`;
}

/** 「使用量 / 総容量」の表記。未測定なら「未測定」。 */
export function formatDiskUsage(usedBytes: number | null, totalBytes: number | null): string {
	return usedBytes !== null && totalBytes !== null && totalBytes > 0
		? `${formatBytes(usedBytes)} / ${formatBytes(totalBytes)}`
		: "未測定";
}
